import { ComponentType } from '~/shared/domain/models';
import { useFieldEvents } from '~/utils/events/field-events';
import type { FormEvent } from 'react';
import type { FieldValues, UseFormRegister } from 'react-hook-form';
import type { AnyFieldSchema } from '~/shared/domain/models';

export const useRegisterWithEvents = () => {
  const { handleOnChange, handleOnBlur } = useFieldEvents();

  const registerWithEvents =
    <T extends FieldValues>(field: AnyFieldSchema, isPII = false) =>
    (register: UseFormRegister<T>) => {
      let onChange: (ev: FormEvent<HTMLInputElement>) => void;
      let onBlur: (ev: FormEvent<HTMLInputElement>) => void;

      switch (field.componentType) {
        case ComponentType.FieldText:
          onBlur = (ev: FormEvent<HTMLInputElement>) => {
            handleOnBlur({
              element_name: field.name,
              field_type: 'short_text',
              element_value: isPII ? '' : ev.currentTarget.value,
            });
          };
          onChange = (ev: FormEvent<HTMLInputElement>) => ev;
          break;
        case ComponentType.FieldTextarea:
          onBlur = (ev: FormEvent<HTMLInputElement>) => {
            handleOnBlur({
              element_name: field.name,
              field_type: 'long_text',
              element_value: ev.currentTarget.value,
            });
          };
          onChange = (ev: FormEvent<HTMLInputElement>) => ev;
          break;
        case ComponentType.FieldCheckbox:
          onChange = (ev: FormEvent<HTMLInputElement>) => {
            handleOnChange({
              element_name: field.name,
              field_type: 'checkbox',
              element_value: ev.currentTarget.value,
            });
          };
          onBlur = (ev: FormEvent<HTMLInputElement>) => ev;
          break;
      }

      const registerCustom: UseFormRegister<T> = (name, opts) => {
        return register(name, {
          ...opts,
          onChange: (ev) => {
            onChange(ev);
          },
          onBlur: (ev) => {
            onBlur(ev);
          },
        });
      };

      return registerCustom;
    };

  return { registerWithEvents };
};
